<template>

  <div class="share_facebook">
    <div class="row">

      <div class="col-12 text-center">
        <h2 class="h3 second-color">{{ $t('accommodation-sharing') }}</h2>
        <p>{{ $t('acc-sharing-modal-title') }} <span class="fw-semibold">{{ accommodation.title }}</span>.</p>

      </div>


      <div class="col-12 d-none"><p>{{ $t('choose-method-of-sharing') }}</p></div>


      <div class="col-12 mt-3">
        <button class="btn btn-facebook btn-rounded rounded w-100 text-center d-flex align-items-center justify-content-center" @click="shareFacebook">
          <TyIcon icon="ty-facebook" width="1rem" height="1rem" stroke_width="400" class="pe-2 icon-color-white"/>
          <span class="text-capitalize">Facebook</span>
        </button>
      </div>

      <div class="col-12 col-md-6 mt-3">
        <button class="btn btn-silver btn-rounded w-100 text-center d-flex align-items-center justify-content-center" @click="copyTopClipboard">
          <TyIcon icon="ty-link" width="1rem" class="pe-2 icon-color-dark"/>
          <span class="text-capitalize" v-if="!copyDone">{{ $t('copy-link') }}</span>
          <span class="text-capitalize" v-else>{{ $t('link-copied') }}</span>
        </button>

        <div id="linkHTMLInput"
             style="position: absolute; z-index: -50;left: -100000px;">
          {{ webUrl }}/{{ activeLocale.code + '-'+ activeCountry.code + '/' + accommodation.link }}
        </div>
      </div>
      <div class="col-12 col-md-6 mt-3">
        <button class="btn btn-silver btn-rounded rounded w-100 text-center d-flex align-items-center justify-content-center" @click="shareEmail">
          <TyIcon icon="ty-email" width="1rem" class="pe-2"/>
          <span class="text-capitalize">{{ $t('email') }}</span>
        </button>
      </div>

    </div>
  </div>

</template>

<script setup lang="ts">
import {obtainActiveLocale, obtainActiveWebCountry} from "~/composables/master_page";
import {PropType, ref} from "vue";
import Accommodation from "~/lib/models/Accommodation";
import {useNuxtApp, useRuntimeConfig} from "#app";

const props = defineProps({
  accommodation: Object as PropType<Accommodation>
})

const {$i18n} = useNuxtApp();
const activeLocale = obtainActiveLocale();
const activeCountry = obtainActiveWebCountry();

const webUrl = useRuntimeConfig().public.WEB_URL;
const copyDone = ref(false);

const shareFacebook = () => {
  window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(location.href), 'facebook-share-dialog', 'width=626,height=436');
};
const shareEmail = () => {
  window.open('mailto:?subject=' + encodeURIComponent($i18n.t('share-accommodataion-prefix-subject') + ' - ' + props.accommodation.title) + '&amp;body=' + $i18n.t('share-accommodation-prefix-text') + ' ' + encodeURIComponent(document.URL));
};
const copyTopClipboard = () => {
  try {
    window.getSelection().selectAllChildren(document.getElementById("linkHTMLInput"));
    document.execCommand("copy");
    copyDone.value = true;
    setTimeout(() => {
      copyDone.value = false;
    }, 5000);
  } catch (e) {
    null;
  }

}
</script>

